import SCENES from '../data/scenes'

export const getScene = state => SCENES[state.currentScene]